export const buildFormData = (
  formData,
  data,
  parentKey
) => {
  if (
    data &&
    typeof data === "object" &&
    !(data instanceof Date) &&
    !(data instanceof File)
  ) {
    Object.keys(data).forEach((key) => {
      if (key === "file" && data[key]?.rawFile) {
        formData.append(key, data[key]?.rawFile);
      } else {
        buildFormData(
          formData,
          data[key],
          parentKey ? `${parentKey}[${key}]` : key
        );
      }
    });
  } else {
    const value = data == null ? "" : data;
    formData.append(parentKey, value);
  }
};
